(function () {
  if (window.milaWidgetLoaded) return;
  window.milaWidgetLoaded = true;

  var API = "https://mila-body-health-ai.onrender.com";
  var cs = /^cs/i.test(document.documentElement.lang || navigator.language || "");
  var T = cs ? {
    open: "Zeptej se průvodce",
    title: "Mila Body Health",
    hello: "Ahoj, jsem průvodce Mila Body Health. Pomůžu ti dát si dohromady, co o svém těle vnímáš, a navrhnu jednoduché kroky péče o sebe. Čím ti dnes můžu být nápomocná?",
    note: "Preventivní péče o sebe, ne zdravotní rada. Nestanovuji diagnózu a nenahrazuji lékaře.",
    ph: "Napiš zprávu…",
    send: "Odeslat",
    wait: "Chvilku, přemýšlím…",
    err: "Teď se mi nepodařilo odpovědět. Zkus to prosím za chvíli."
  } : {
    open: "Ask the guide",
    title: "Mila Body Health",
    hello: "Hi, I'm the Mila Body Health guide. I help you put together what you notice about your body and suggest simple self-care steps. What would you like to talk about today?",
    note: "Preventive self-care, not medical advice. I don't diagnose and don't replace a doctor.",
    ph: "Write a message…",
    send: "Send",
    wait: "One moment, thinking…",
    err: "I couldn't answer just now. Please try again in a moment."
  };

  var css = document.createElement("style");
  css.textContent =
    "#mila-btn{position:fixed;left:22px;bottom:22px;z-index:9998;background:#0E2390;color:#FAF8F4;border:0;border-radius:999px;padding:13px 20px;font:600 14px/1 inherit;cursor:pointer;box-shadow:0 6px 20px rgba(14,35,144,.25)}" +
    "#mila-box{position:fixed;left:22px;bottom:22px;z-index:9999;width:360px;max-width:calc(100vw - 32px);height:540px;max-height:calc(100vh - 44px);background:#FAF8F4;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.2);display:none;flex-direction:column;overflow:hidden;font-family:inherit}" +
    "#mila-head{background:#0E2390;color:#FAF8F4;padding:14px 16px;display:flex;justify-content:space-between;align-items:center;font-weight:600}" +
    "#mila-head button{background:none;border:0;color:#FAF8F4;font-size:22px;cursor:pointer;line-height:1}" +
    "#mila-note{font-size:11px;color:#555;padding:8px 14px;border-bottom:1px solid #DCD5C9}" +
    "#mila-msgs{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px}" +
    ".mila-m{max-width:85%;padding:10px 13px;border-radius:14px;font-size:14px;line-height:1.45;white-space:pre-wrap}" +
    ".mila-a{background:#DCD5C9;color:#1a1a1a;align-self:flex-start}" +
    ".mila-u{background:#0E2390;color:#FAF8F4;align-self:flex-end}" +
    ".mila-acts{display:flex;flex-wrap:wrap;gap:8px;align-self:flex-start}" +
    ".mila-acts a{border:1.5px solid #0E2390;color:#0E2390;border-radius:999px;padding:7px 13px;font-size:13px;text-decoration:none;font-weight:600;background:#FAF8F4}" +
    "#mila-form{display:flex;gap:8px;padding:10px;border-top:1px solid #DCD5C9}" +
    "#mila-in{flex:1;border:1px solid #DCD5C9;border-radius:999px;padding:10px 14px;font-size:14px;background:#fff}" +
    "#mila-send{background:#0E2390;color:#FAF8F4;border:0;border-radius:999px;padding:0 16px;font-weight:600;cursor:pointer}";
  document.head.appendChild(css);

  function el(tag, props, parent) {
    var e = document.createElement(tag);
    for (var k in (props || {})) e[k] = props[k];
    if (parent) parent.appendChild(e);
    return e;
  }

  var btn = el("button", { id: "mila-btn", textContent: T.open }, document.body);
  var box = el("div", { id: "mila-box" }, document.body);
  var head = el("div", { id: "mila-head" }, box);
  el("span", { textContent: T.title }, head);
  var close = el("button", { textContent: "×", ariaLabel: "Close" }, head);
  el("div", { id: "mila-note", textContent: T.note }, box);
  var msgs = el("div", { id: "mila-msgs" }, box);
  var form = el("form", { id: "mila-form" }, box);
  var input = el("input", { id: "mila-in", placeholder: T.ph, maxLength: 2000 }, form);
  el("button", { id: "mila-send", type: "submit", textContent: T.send }, form);

  var history = [];

  function add(text, cls) {
    return el("div", { className: "mila-m " + cls, textContent: text }, msgs);
  }
  function scroll() { msgs.scrollTop = msgs.scrollHeight; }
  function addActions(actions) {
    if (!actions || !actions.length) return;
    var row = el("div", { className: "mila-acts" }, msgs);
    actions.forEach(function (a) {
      var ok = typeof a.path === "string" && (a.path.charAt(0) === "/" || /^https:\/\//.test(a.path));
      if (!ok) return;
      el("a", { href: a.path, textContent: a.label }, row);
    });
  }

  add(T.hello, "mila-a");

  btn.onclick = function () { btn.style.display = "none"; box.style.display = "flex"; input.focus(); };
  close.onclick = function () { box.style.display = "none"; btn.style.display = "block"; };

  form.onsubmit = function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text) return;
    input.value = "";
    add(text, "mila-u");
    history.push({ role: "user", content: text });
    var wait = add(T.wait, "mila-a");
    scroll();
    fetch(API + "/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: history.slice(-20) })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        wait.textContent = d.reply || T.err;
        history.push({ role: "assistant", content: d.reply || "" });
        addActions(d.actions);
        scroll();
      })
      .catch(function () { wait.textContent = T.err; history.pop(); scroll(); });
  };
})();